import React from 'react'
import Fullpage from './Fullpage';
import TopNav from './components/TopNav';
import { handlePageNumber } from './redux/actions';
import { useDispatch, useSelector } from 'react-redux';

const App = () => {
  const dispatch = useDispatch();

  let pageNo = useSelector(state=> state.pageNo);
  console.log("page-array",pageNo);

  return (
    <>
       <img 
        src='/assets/madhya-logo.png' 
        alt=''
        className='madhya-logo'
        onClick={()=> {
          dispatch(handlePageNumber(1)); 
        }}
       />
       
       <TopNav />
       <Fullpage  />

       <a data-menuanchor="top" href="#" class="top-arrow my-btn"  onClick={(e) => {
          e.preventDefault();
          dispatch(handlePageNumber(1));

          // delay moveTo slightly to let fullpage.js process everything
          setTimeout(() => {
            if (window.fullpage_api) {
              window.fullpage_api.moveTo(1);
              setTimeout(() => {
                window.fullpage_api.reBuild(); 
              }, 300);
            }
          }, 50);
        }}>
         <i class="fa-solid fa-arrow-up"></i>
       </a>
      
    </>
  )
}

export default App;